import { z } from "zod"

import { ADMIN_ROLES } from "@/constants/roles"

export const createAdminUserSchema = z.object({
  institution_id: z.string().min(1, "required"),
  email: z.string().trim().min(1, "required").email("invalid_email"),
  full_name: z.string().trim().min(1, "required").max(200, "too_long"),
  role: z.enum(ADMIN_ROLES),
})

export type CreateAdminUserInput = z.infer<typeof createAdminUserSchema>

// Edit cannot move institutions or change email here; only name + role.
export const editAdminUserSchema = z.object({
  full_name: z.string().trim().min(1, "required").max(200, "too_long"),
  role: z.enum(ADMIN_ROLES),
})

export type EditAdminUserInput = z.infer<typeof editAdminUserSchema>
